import { render } from "./FreeClass.vue?vue&type=template&id=00687bb9&scoped=true&ts=true"
import script from "./FreeClass.vue?vue&type=script&lang=ts"
export * from "./FreeClass.vue?vue&type=script&lang=ts"

import "./FreeClass.vue?vue&type=style&index=0&id=00687bb9&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00687bb9"]])

export default __exports__